module.exports = __webpack_public_path__ + "static/assets/d7babf2cf5a96ff9720dd7219d406442.svg";